import ActionDispatcherService from '../../common/actions/core/action-dispatcher.service';
import { ActionHandler } from '../../common/actions/core/action-handler';
import { Action } from '../../common/actions/core/action';
import { ContractApproveAction } from '../../common/actions/contract-approve-action';
import angular = require('angular');
import NotificationService from '../../common/services/notification/notification.service';

/* @ngInject */
export default class ContractsController implements ActionHandler {
  private infoForm: string;
  private distantSalesForm: string;
  private unsubscribeTranslateChange: () => void;

  private preInfoAggreement: boolean = false;
  private distantAggreement: boolean = false;
  private aggreement: boolean = false;

  private onConfirm: any;
  private onDistantSales: any;
  private onPreInfo: any;
  private showPreInfo: boolean = true;
  private disableChecked: boolean = false;

  constructor(
    private $sce,
    private $translate,
    private $rootScope,
    private actionDispatcher: ActionDispatcherService,
    private notificationService: NotificationService
  ) {
    this.loadTranslations();
    this.unsubscribeTranslateChange = this.$rootScope.$on(
      '$translateChangeSuccess',
      () => this.loadTranslations()
    );
  }

  public loadTranslations() {
    this.$translate('pay.infoForm').then(value => {
      this.infoForm = this.$sce.trustAsHtml(value);
    });

    this.$translate('pay.distantSalesForm').then(value => {
      this.distantSalesForm = this.$sce.trustAsHtml(value);
    });

  }

  public $postLink() {
    this.actionDispatcher.register(this);
  }

  public $onDestroy() {
    this.actionDispatcher.unregister(this);
    this.unsubscribeTranslateChange();
  }

  public onContractLinkClick(event) {
    const target = angular.element(event.target);
    if (target.closest('.distant', event.currentTarget).length) {
      event.preventDefault();
      this.onDistantSalesForm();
    } else if (target.closest('.info-form', event.currentTarget).length) {
      event.preventDefault();
      this.onInfoForm();
    }
  }

  public handle(action: Action) {
    if (action instanceof ContractApproveAction) {
      if (action.data && action.data.aggreement) {
        this.approveAggreement();
      }
    }
  }

  public onInfoForm() {
    this.onPreInfo();
  }

  public onDistantSalesForm() {
    this.onDistantSales();
  }

  private approveAggreement() {
    this.aggreement = true;
    this.confirmContract();
  }

  public onChangeContract() {
    if(this.disableChecked) {
      this.$translate('payment.contract.cardAdd.warning').then(value => {
        this.notificationService.showNotification({
          text: value,
          type: 'warning'
        });
      });
      
      this.aggreement = false;
    }
    this.confirmContract();
  }

  private confirmContract() {
    this.onConfirm({
      data: {
        aggreement: this.aggreement
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/buy/contracts/contracts.controller.ts